import { css } from '@emotion/react';

import { disableUserSelect } from 'src/styles/styles';

import { colors } from '../../styles/colors';
import { ZeeFontRegular } from '../../styles/font';
import { flex } from '../../styles/utils';

export const socialDiv = css`
  width: 100%;
`;

export const loginhrLine = css`
  border-bottom: 1px solid ${colors.GrayAlbhaPoint36};
  margin: 40px auto 40px;
  width: 40%;
  height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 0.1em;
  text-align: center;
`;

export const loginhrLineSpan = css`
  background-color: ${colors.white};
  color: ${colors.GrayAlbhaPoint54};
  padding: 0 5px;
  text-transform: uppercase;
  display: inline-block;
  ${ZeeFontRegular(16)}
`;

export const contineWith = css`
  color: ${colors.AccentDarkGrayColor};
  ${ZeeFontRegular(20, 25)}
  padding-bottom: 16px;
  text-align: center;
`;

export const socialIconsFooter = css`
  ${flex('row', 'center')}
  gap: 24px;
  text-align: center;
  margin: 0 10px 30px;
`;

export const socialIcons = css`
  ${disableUserSelect};
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const LogoIcon = css`
  border-radius: 50%;
  box-shadow: 0 0 2px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
`;
